/**
 * 检查返回
 */
export function checkResponse(response) {
  if (response.code === '0000') {
    return true
  } else {
    return false
  }
}

/**
 * 是否空对象
 */
export function isEmptyObj(obj) {
  if (obj === null || obj === undefined || obj === 'undefined') {
    return true
  } else {
    if (Object.keys(obj).length === 0) {
      return true
    }
    return false
  }
}

/**
 * 属性是否为空
 */
export function isEmpty(val) {
  if (val === "" || val === 'undefined' || val === null || val === undefined) {
    return true
  } else {
    return false
  }
}

/**
 * 左补指定字符
 */
export function padLeftChar(value, len, padChar = '0') {
  return (Array(len).join(padChar) + value).slice(-len)
}

/**
 * resolve
 */
export function qunjiResolve(response, vm) {
  let sendMessage = () => {
    if (typeof response === 'string') {
      vm.$message.success(response)
    } else if (response && response.message) {
      vm.$message.success(response.message)
    }
  }
  if (typeof response === 'function') {
    response()
  } else if (response && typeof response.callback === 'function') {
    (response.callback)()
    sendMessage()
  } else {
    sendMessage()
  }
}

/**
 * reject
 */
export function qunjiReject(error, vm) {
  let sendMessage = () => {
    if (typeof error === 'string') {
      vm.$alert(error)
    } else if (error && error.message) {
      vm.$alert(error.message)
    }
  }
  if (typeof error === 'function') {
    error()
  } else if (error && typeof error.callback === 'function') {
    (error.callback)()
    sendMessage()
  } else {
    sendMessage()
  }
}

